
import { Vue, Component } from "vue-property-decorator";
import MainLayout from "@/layout/Main.vue";

@Component({
  components: { MainLayout },
})
export default class App extends Vue {}
